import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import { BoardMembershipRoles } from '../constants/Enums';
import List from '../components/List';

const makeMapStateToProps = () => {
  const selectListById = selectors.makeSelectListById();
  const selectCardIdsByListId = selectors.makeSelectCardIdsByListId();
  const selectCardIdsByQuadrant = selectors.makeSelectCardIdsByQuadrant();

  return (state, { id, index }) => {
    const { name, color, viewMode, isActive, isPersisted } = selectListById(state, id);
    const cardIds = selectCardIdsByListId(state, id);
    const cardIdsByQuadrant = selectCardIdsByQuadrant(state, id);
    const currentUserMembership = selectors.selectCurrentUserMembershipForCurrentBoard(state);

    const isCurrentUserEditor =
      !!currentUserMembership && currentUserMembership.role === BoardMembershipRoles.EDITOR;

    return {
      id,
      index,
      name,
      color,
      // FAMILY-EXT: матрица Эйзенхауэра
      viewMode: viewMode || 'default',
      cardIdsByQuadrant,
      // FAMILY-EXT: фильтр "Только активные"
      isActive: !!isActive,
      isPersisted,
      cardIds,
      canEdit: isCurrentUserEditor,
    };
  };
};

const mapDispatchToProps = (dispatch, { id }) =>
  bindActionCreators(
    {
      onUpdate: (data) => entryActions.updateList(id, data),
      onSort: (data) => entryActions.sortList(id, data),
      onDelete: () => entryActions.deleteList(id),
      onCardCreate: (data, autoOpen, addToTop) =>
        entryActions.createCard(id, data, autoOpen, addToTop),
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(List);
